import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import IncFormHelperText, {
  IncFormHelperTextProps,
} from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { SyntheticEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type CheckboxFieldProps = {
  name: string;
  label: string;
  helperText?: React.ReactNode;
  handleChange?: (event: SyntheticEvent<Element, Event>) => typeof event;
  fieldProps?: any;
  fieldErrorHandled?: boolean;
  disabled?: boolean;
  sxhelperText?: Object;
  showHelperText?: boolean;
  helperTextSeverity?: IncFormHelperTextProps['severity'];
};

const CheckboxField = ({
  name,
  label,
  helperText,
  handleChange = e => e,
  fieldProps = {},
  fieldErrorHandled = false,
  disabled,
  helperTextSeverity,
  sxhelperText,
  showHelperText = true,
  ...rest
}: CheckboxFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { ref, onChange, ...fieldRest },
        fieldState: { error },
      }) => (
        <FormControl
          error={!!error}
          fullWidth={false}
          sx={{ display: 'block' }}
          disabled={disabled}
          {...rest}
        >
          <FormControlLabel
            {...fieldRest}
            inputRef={ref}
            label={label}
            onChange={e => {
              onChange(handleChange(e));
            }}
            checked={fieldRest.value === true}
            control={<Checkbox />}
            {...fieldProps}
          />
          {!fieldErrorHandled && showHelperText && (
            <FormHelperText sx={{ mt: -1, ...sxhelperText }}>
              <IncFormHelperText
                error={error}
                helperText={helperText}
                severity={helperTextSeverity}
              />
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default CheckboxField;
